export const defaultStyles = {
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingRight: "0",
    paddingLeft: "0",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginRight: "0",
    marginLeft: "0",
  },
} as const;
